export const TabLabel = (labelFor, labelText) => `    
    <label for="tab-slider-${labelFor}" class="sd-label">${labelText}
`;